import * as joint from "jointjs";

export const createEditElementTool = () =>
  new joint.elementTools.Button({
    markup: [
      {
        tagName: "circle",
        selector: "button",
        attributes: {
          cx: 10,
          cy: 10,
          r: 10,
          fill: "#FFFFFF",
          cursor: "pointer",
        },
      },
      {
        tagName: "path",
        attributes: {
          fill: "none",
          stroke: "black",
          transform: "translate(10 10)",
          d: "M -4 4 L -4 1.5 L 2 -4.5 L 4.5 -2 L -1.5 4 Z M 1 -3.5 L 3.5 -1",
          cursor: "pointer",
        },
      },
    ],
    x: "50%",
    y: "100%",
    offset: { x: -24, y: 14 },
    action: function () {
      // @ts-ignore
      this.paper.trigger("keaelement:rename", this);
    },
  });
